import { Component } from '@angular/core';

@Component({
    selector: 'app-blank-layout',
    templateUrl: './blank-layout.component.html'
})

export class BlankLayoutComponent  {
    constructor() { }
}